import ItemCardContentWithAttributesAndFiles from './itemCardContentWithAttributesAndFiles'

export default ItemCardContentWithAttributesAndFiles
